export default {
  getFilters: state => state.filter,
  getAdvancedFilters: state => {
    let allFilters = { ...state.filter }
    let filtersArray = []

    filtersArray = Object.entries(allFilters)
      .map(([key, value]) => {
        if (key === "chain" || key === "pos") {
          return value.map(item => ({
            key: item.label,
            value: item.value,
            name: item.name,
            label: item.label
          }))
        } else {
          return {
            key,
            value
          }
        }
      })
      .flat()
    return filtersArray
  },
  getSuspensionTypes: state => state.suspensionTypes
}
